"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncNavigator = exports.getClientAsyncNavigator = exports.EAsyncNavigatorTimePosition = exports.ENavigationMetaPageType = exports.EEndTags_AsyncNavigator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ExecutionEnvironmentUtils_1 = require("@gt/common-utils/build/general/ExecutionEnvironmentUtils");
const TaskFunctionResponses_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionResponses");
const TaskFunctionTypes_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionTypes");
const TaskFunctionUtils_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionUtils");
const immer_1 = __importDefault(require("immer"));
const query_string_1 = __importDefault(require("query-string"));
const react_1 = require("react");
const ReactRouterPathMatching_1 = require("./ReactRouterPathMatching");
const { matchPath } = ReactRouterPathMatching_1.ReactRouterPathMatching;
var EEndTags_AsyncNavigator;
(function (EEndTags_AsyncNavigator) {
    EEndTags_AsyncNavigator["async_navigator_route_not_found"] = "async_navigator_route_not_found";
})(EEndTags_AsyncNavigator || (exports.EEndTags_AsyncNavigator = EEndTags_AsyncNavigator = {}));
var ENavigationMetaPageType;
(function (ENavigationMetaPageType) {
    ENavigationMetaPageType["regular"] = "regular";
    ENavigationMetaPageType["maintenance"] = "maintenance";
    ENavigationMetaPageType["not_found"] = "not_found";
    ENavigationMetaPageType["unknown_error"] = "unknown_error";
})(ENavigationMetaPageType || (exports.ENavigationMetaPageType = ENavigationMetaPageType = {}));
var EAsyncNavigatorTimePosition;
(function (EAsyncNavigatorTimePosition) {
    EAsyncNavigatorTimePosition["THROW"] = "THROW";
    EAsyncNavigatorTimePosition["START"] = "START";
    EAsyncNavigatorTimePosition["STEP"] = "STEP";
    EAsyncNavigatorTimePosition["END_REDIRECT"] = "END_REDIRECT";
    EAsyncNavigatorTimePosition["END"] = "END";
})(EAsyncNavigatorTimePosition || (exports.EAsyncNavigatorTimePosition = EAsyncNavigatorTimePosition = {}));
let AsyncNavigatorSingleton;
const getClientAsyncNavigator = () => {
    if (AsyncNavigatorSingleton == null) {
        throw Error(`Async Navigator: Tried to run getAsyncNavigator(), but it hasn't been created yet.`);
    }
    if (ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isNode()) {
        throw Error(`Async Navigator: Can't run getAsyncNavigator() on the server. This is a client-only function.`);
    }
    return AsyncNavigatorSingleton;
};
exports.getClientAsyncNavigator = getClientAsyncNavigator;
class AsyncNavigator {
    resolvers = [];
    getReactState;
    onFinishResolve;
    onClientNavigate;
    getDefaultMeta;
    asyncState = { currentActionOrd: 0, defaultState: undefined };
    listeners = [];
    currentState;
    constructor({ getReactState, onFinishResolve, getDefaultMeta, }) {
        this.getReactState = getReactState;
        this.onFinishResolve = onFinishResolve;
        this.getDefaultMeta = getDefaultMeta;
        AsyncNavigatorSingleton = this;
    }
    Link = ({ to, query, children, onClick, style, ...rootProps }) => {
        const { go } = this.useAsyncNavigation();
        function handleClick(event) {
            if (onClick) {
                onClick(event);
            }
            if (!event.defaultPrevented && // onClick prevented default
                event.button === 0 // Ignore everything but left clicks
            ) {
                event.preventDefault();
                go(to, { query });
            }
        }
        return ((0, jsx_runtime_1.jsx)("a", { href: to, style: { display: "contents", ...style }, onClick: handleClick, ...rootProps, children: children }));
    };
    /*createReactContext(): React.Context<AsyncNavigator<S, M>> {
      return React.createContext<AsyncNavigator<S, M>>(this);
    }*/
    setOnClientNavigate(onClientNavigate) {
        this.onClientNavigate = onClientNavigate;
    }
    async _go(path, state, { nav = true, query } = {}) {
        while (true) {
            const ctx = {
                path,
                query,
                errors: [],
                status: 200,
            };
            console.log(`ASYNC NAV: Starting`, ctx);
            this.asyncState.currentActionOrd += 1;
            const thisActionOrd = this.asyncState.currentActionOrd;
            let started = false;
            const matchInfo = [];
            const resolverErrors = [];
            const results = [];
            const toRunAfterInputsAndFuncs = [];
            let matchInfoAndMeta = undefined;
            const alreadyMatchedIndexes = [];
            let fallthrough = true;
            while (fallthrough) {
                ctx.fallthrough = false;
                const toResolve = [];
                const preMatchedIndexesLength = alreadyMatchedIndexes.length;
                let resolverIndex = -1;
                let currentParallelIdentifier;
                for (const { resolve, runAfter, paths, meta, parallel = false, shouldSkip } of this
                    .resolvers) {
                    resolverIndex += 1;
                    let match = null;
                    for (const mPath of paths) {
                        match = matchPath(mPath, path);
                        if (match != null) {
                            break;
                        }
                    }
                    if (match != null && !alreadyMatchedIndexes.includes(resolverIndex)) {
                        alreadyMatchedIndexes.push(resolverIndex);
                        if (matchInfoAndMeta == null) {
                            matchInfoAndMeta = {
                                match,
                                meta: Object.assign(this.getDefaultMeta(), meta),
                                skipped: false,
                            };
                        }
                        else {
                            matchInfoAndMeta.match = match;
                            matchInfoAndMeta.meta = Object.assign(matchInfoAndMeta.meta, meta);
                        }
                        const resolverArgs = {
                            info: match,
                            state,
                            ctx,
                            updateMeta: (updater) => {
                                matchInfoAndMeta.meta = (0, immer_1.default)(matchInfoAndMeta.meta, (s) => {
                                    updater(s, matchInfoAndMeta.meta);
                                });
                            },
                        };
                        if (!(shouldSkip?.(resolverArgs) ?? false) && resolve != null) {
                            toRunAfterInputsAndFuncs.push({ inputs: resolverArgs, func: runAfter });
                            toResolve.push(resolve(resolverArgs).catch((e) => {
                                resolverErrors.push({
                                    index: resolverIndex,
                                    error: e instanceof TaskFunctionUtils_1.TaskFunctionError
                                        ? e
                                        : new TaskFunctionUtils_1.TaskFunctionError((0, TaskFunctionResponses_1.TFRFailure)(TaskFunctionTypes_1.ETaskFunctionEndId.ERROR, `Async Navigation Error pathname(${match?.pathname}), path(${match?.path}): ${e.message}`, e)),
                                    info: matchInfoAndMeta,
                                });
                            }));
                            if (typeof parallel === "boolean") {
                                if (!parallel) {
                                    matchInfo.push(matchInfoAndMeta);
                                    break;
                                }
                            }
                            else if (currentParallelIdentifier === undefined) {
                                currentParallelIdentifier = parallel;
                            }
                            else if (currentParallelIdentifier !== parallel) {
                                matchInfo.push(matchInfoAndMeta);
                                break;
                            }
                        }
                        else {
                            matchInfoAndMeta.skipped = true;
                        }
                        matchInfo.push(matchInfoAndMeta);
                    }
                }
                if (alreadyMatchedIndexes.length === 0) {
                    const error = new TaskFunctionUtils_1.TaskFunctionError((0, TaskFunctionResponses_1.TFRFailureDefaults)({
                        endId: TaskFunctionTypes_1.ETaskFunctionEndId.NOT_FOUND,
                        endMessage: `Async Navigation Error: No resolver matched for path`,
                        endTags: [EEndTags_AsyncNavigator.async_navigator_route_not_found],
                    }));
                    ctx.errors = [
                        {
                            error,
                            index: -1,
                            info: {},
                        },
                    ];
                    ctx.status = TaskFunctionUtils_1.TaskFunctionUtils.getHttpStatusCodeForEndId(TaskFunctionTypes_1.ETaskFunctionEndId.NOT_FOUND);
                    this.listeners.forEach((l) => l({
                        results,
                        matchInfo,
                        state,
                        ctx,
                        ord: this.asyncState.currentActionOrd,
                        pos: EAsyncNavigatorTimePosition.THROW,
                    }));
                    throw error;
                }
                if (preMatchedIndexesLength === alreadyMatchedIndexes.length) {
                    console.warn(`Async Navigator Warning: Router "fell through"- but didn't match any other routes further down`);
                }
                this.listeners.forEach((l) => l({
                    results,
                    matchInfo,
                    state,
                    ctx,
                    ord: this.asyncState.currentActionOrd,
                    pos: !started ? EAsyncNavigatorTimePosition.START : EAsyncNavigatorTimePosition.STEP,
                }));
                const currentResults = await Promise.all(toResolve);
                results.push(...currentResults);
                started = true;
                if (ctx.redirect == null) {
                    fallthrough = ctx.fallthrough;
                }
                else {
                    fallthrough = false;
                }
            }
            if (resolverErrors.length > 0) {
                console.error(`ASYNC NAV: Some resolvers failed to resolve state correctly for path ${path}`);
                console.error(resolverErrors
                    .map((e) => TaskFunctionUtils_1.TaskFunctionUtils.printTaskFunctionError(e.error.taskFunctionResponse))
                    .join(", "));
                ctx.errors = resolverErrors;
                ctx.status = TaskFunctionUtils_1.TaskFunctionUtils.getHttpStatusCodeForEndId(resolverErrors[0].error.taskFunctionResponse.endId);
                if (thisActionOrd === this.asyncState.currentActionOrd) {
                    this.onFinishResolve?.({
                        state,
                        ctx,
                        matchInfo,
                        results,
                    });
                }
            }
            else {
                const withRedirect = ctx.redirect ? ` and REDIRECTING to: [ ${ctx.redirect.path} ]` : "";
                console.log(`ASYNC NAV: Resolved for path: [ ${path === ctx.path ? path : `${path} -REWRITTEN-> ${ctx.path}`} ]${withRedirect}`);
                if (thisActionOrd === this.asyncState.currentActionOrd) {
                    if (ctx.redirect) {
                        this.listeners.forEach((l) => l({
                            results,
                            matchInfo,
                            state,
                            ctx,
                            ord: this.asyncState.currentActionOrd,
                            pos: EAsyncNavigatorTimePosition.END_REDIRECT,
                        }));
                        if (nav) {
                            path = ctx.redirect.path;
                            query = ctx.redirect.query;
                            continue;
                        }
                    }
                    else if (nav) {
                        this.onClientNavigate({
                            path: ctx.path,
                            query: ctx.query,
                        });
                    }
                    toRunAfterInputsAndFuncs.forEach(({ func, inputs }, index) => {
                        func?.(results[index], inputs);
                    });
                    this.onFinishResolve?.({
                        state,
                        ctx,
                        matchInfo,
                        results,
                    });
                }
            }
            this.listeners.forEach((l) => l({
                results,
                matchInfo,
                state,
                ctx,
                ord: this.asyncState.currentActionOrd,
                pos: EAsyncNavigatorTimePosition.END,
            }));
            return {
                ctx,
                matchInfo,
                results,
            };
        }
    }
    go(path, options) {
        return this._go(path, this.asyncState.defaultState != null ? this.asyncState.defaultState : {}, options);
    }
    useAsyncNavigation() {
        const state = this.getReactState?.() ?? {};
        return {
            go: (path, options) => this._go(path, state, options),
        };
    }
    setDefaultState(state) {
        this.asyncState.defaultState = state;
    }
    listen(listener, ssrListener = false) {
        if (typeof document !== "undefined" || ssrListener) {
            this.listeners.push(listener);
        }
        return () => {
            this.listeners.filter((l) => l !== listener);
        };
    }
    execute(path, state = this.asyncState.defaultState != null ? this.asyncState.defaultState : {}, options = {}) {
        return this._go(path, state, {
            nav: false,
            ...options,
        });
    }
    clientRefresh() {
        if (ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isBrowser()) {
            // window.location
            return this._go(window.location.pathname, this.asyncState.defaultState ?? {}, {
                query: query_string_1.default.parse(window.location.search),
            });
        }
        else {
            throw new Error(`Can't run Async Navigator "clientRefresh()" on Node.js - this is meant as a client-side only method`);
        }
    }
    useAsyncNavigatorState() {
        const [isLoading, setIsLoading] = (0, react_1.useState)(this.currentState?.pos === EAsyncNavigatorTimePosition.START);
        const [errors, setErrors] = (0, react_1.useState)(this.currentState?.ctx.errors?.map((e) => e.error.taskFunctionResponse) ?? []);
        (0, react_1.useEffect)(() => {
            const effectState = {
                ord: this.currentState?.ord ?? -1,
                shouldUpdate: true,
                timeout: null,
            };
            // let timeout: any;
            // let ord = -1;
            const unregister = this.listen((nav) => {
                if (nav.pos === EAsyncNavigatorTimePosition.THROW && nav.ord >= effectState.ord) {
                    effectState.ord = nav.ord;
                    clearTimeout(effectState.timeout);
                    if (effectState.shouldUpdate) {
                        setIsLoading(false);
                        if (nav.ctx.errors.length > 0) {
                            setErrors(nav.ctx.errors.map((e) => e.error.taskFunctionResponse));
                        }
                    }
                }
                else {
                    if (nav.pos === EAsyncNavigatorTimePosition.START) {
                        effectState.ord = nav.ord;
                        clearTimeout(effectState.timeout);
                        effectState.timeout = setTimeout(() => {
                            if (effectState.shouldUpdate) {
                                setIsLoading(true);
                            }
                        }, 100);
                    }
                    else if (nav.pos === EAsyncNavigatorTimePosition.END && nav.ord === effectState.ord) {
                        clearTimeout(effectState.timeout);
                        if (effectState.shouldUpdate) {
                            setIsLoading(false);
                            if (nav.ctx.errors.length > 0) {
                                setErrors(nav.ctx.errors.map((e) => e.error.taskFunctionResponse));
                            }
                        }
                    }
                }
            });
            return () => {
                effectState.shouldUpdate = false;
                clearTimeout(effectState.timeout);
                unregister();
            };
        }, []);
        return {
            errors,
            isLoading,
            clearErrors: () => setErrors([]),
        };
    }
    addRoute(resolver) {
        this.resolvers.push(resolver);
    }
    addRedirect(paths, redirect) {
        this.resolvers.push({
            paths,
            resolve: async ({ ctx }) => {
                if (ctx.path !== redirect.path) {
                    ctx.redirect = redirect;
                }
            },
        });
    }
    addRoutes(resolvers) {
        this.resolvers.push(...resolvers);
    }
}
exports.AsyncNavigator = AsyncNavigator;
